import { __decorate, __metadata } from "tslib";
import { IsNotEmpty, IsString, IsUUID } from 'class-validator';
/**
 * The request to validate a User's MFA Recovery Code
 */
export class ValidateRecoveryCodeBody {
    /**
     * @param userId identifies the user whose code belongs to
     * @param recoveryCode the code to be validated
     */
    constructor(userId, recoveryCode) {
        this.userId = userId;
        this.recoveryCode = recoveryCode;
    }
}
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], ValidateRecoveryCodeBody.prototype, "userId", void 0);
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], ValidateRecoveryCodeBody.prototype, "recoveryCode", void 0);
